import { Injectable, inject, Optional, Inject } from '@angular/core';
import { HttpCoreService } from '@dataclouder/ngx-core';
import { TTSRequest, TTSVoice } from '../../../models/tts-models';
import { TTS_API_URL } from '../tokens';
import { VertexRoutes } from '../../../models/enums-vertex-routes';

// Define the AudioGenerated type for the return value of getTextAudioFile
export interface AudioTTSService {
  blob: Blob | null;
  blobUrl: string | null;
  transcription: any | null;
}

@Injectable({
  providedIn: 'root',
})
export class TtsService {
  private httpService = inject(HttpCoreService);

  constructor(@Optional() @Inject(TTS_API_URL) apiUrl: string | null) {}

  /**
   * Lists available voices for a specific language code
   * @param languageCode The language code (e.g., 'en', 'es')
   * @returns Promise with the list of available voices
   */
  public async listVoices(languageCode: string = ''): Promise<TTSVoice[]> {
    let route = VertexRoutes.tts.listVoices;
    if (languageCode) {
      route += `?languageCode=${languageCode}`;
    }
    const response = await this.httpService.get<TTSVoice[]>(route);

    return response;
  }

  /**
   * Generates an audio file from text using the TTS API
   * @param tts The TTS request parameters
   * @returns Promise with the audio data including blob URL and transcription
   */
  public async getTextAudioFile(tts: TTSRequest): Promise<AudioTTSService> {
    const httpReq = await this.httpService.postFileAndGetBlob(VertexRoutes.tts.synthesize, tts, 'secondary');
    const audioData: AudioTTSService = { blobUrl: null, transcription: null, blob: null };

    const transcription = httpReq?.headers.get('transcription');

    if (transcription) {
      const data = JSON.parse(transcription);
      audioData.transcription = data;
    }

    audioData.blob = httpReq.body;

    audioData.blobUrl = window.URL.createObjectURL(audioData.blob);

    return audioData;
  }
}
